import { useContext } from 'react';

import { DwellTimeContext } from './dwell-tracker-context.tsx';

export interface UseDwellTimeElementAttributesProps {
	id: string;
}

export interface DwellTimeElementAttributes {
	'data-dwell-id'?: string;
}

/**
 * Returns attributes opting a DOM element into dwell tracking.
 * Hard-coded to `data-dwell-id` + any-pixel visibility (threshold `0`);
 * custom (>0) thresholds will be supported once the per-element threshold
 * rework lands (GWP-12180). Returns `{}` when tracking is disabled.
 */
export function useDwellTimeElementAttributes({
	id,
}: UseDwellTimeElementAttributesProps): DwellTimeElementAttributes {
	const context = useContext(DwellTimeContext);
	return context?.enabled ? { 'data-dwell-id': id } : {};
}
